module.exports = __webpack_public_path__ + "img/ic_chevron_right_black_48px.2786169c.svg";